export default {
  target: {
    width: '90px',
    border: 0,
    '& .MuiOutlinedInput-notchedOutline': {
      borderRadius: 0,
      border: 'none',
    },
  },
  input: (params) => ({
    '& .MuiInputBase-input': {
      borderRadius: '20px',
      padding: '4px 8px !important',
      textAlign: 'center',
      fontSize: '0.875rem',
      width: 'auto !important',
      minWidth: '0 !important',
      lineHeight: 1,
      ...params,
    },
  }),
};
